/**
 * 
 * key
 * 
 */


const key = 'bXlDbGllbnRRY0NvbXBsZXRlZA=='

export default key 